import { css } from 'styled-components'

export default css`
  position: relative;
  flex-shrink: 0;

  .payment-history-status-handle {
    .status-label {
      white-space: nowrap;
    }

    .chevron {
      transform: rotate(180deg);
      transition: transform 200ms ease-out;

      &.open {
        transform: rotate(0deg);
      }
    }
  }
`
